/**
 * Site identity for UI (which host this console is served from).
 * This is not Node/Vite build mode (`import.meta.env.MODE`).
 */
export function getSiteHost(): string {
  if (typeof window === "undefined") return "";
  return window.location.host;
}
